export default __webpack_public_path__ + "static/runway-01-dc3d92566b6093c61e2b8f7323816274.mp4";